import React from 'react';
import { Booking } from '../../types';
import CheckIcon from '../icons/CheckIcon';
import { BookingDataView, BookingDataViewType } from './BookingDataView';
import { bookingStrings, str } from './strings';

const confirmationStrings = bookingStrings.confirmation.success;

interface BookingConfirmationProps {
    confirmationData: Booking;
    closeConfirmation: () => void;
    rescheduleBooking: () => void;
    cancelBooking: () => void;
}

const BookingConfirmation = ({
    confirmationData,
    closeConfirmation,
    rescheduleBooking,
    cancelBooking,
}: BookingConfirmationProps) => (
    <BookingDataView
        bookingData={confirmationData}
        dataAuto='booking-confirmation-screen'
        onClose={closeConfirmation}
        type={BookingDataViewType.SUCCESS}
        title={str(confirmationStrings.title)}
        svgIcon={<CheckIcon />}
    >
        <label>{str(confirmationStrings.change)}</label>
        <span
            onClick={rescheduleBooking}
            data-auto='booking-confirmation-reschedule-button'
        >
            {str(confirmationStrings.reschedule)}
        </span>
        <label>{str(confirmationStrings.or)}</label>
        <span
            onClick={cancelBooking}
            data-auto='booking-confirmation-cancel-button'
        >
            {str(confirmationStrings.cancel)}
        </span>
    </BookingDataView>
);

export default BookingConfirmation;
